module.exports = "<main class=\"main\"><div class=\"main-background main-background-first\"></div><div class=\"main-background main-background-second\"></div><div class=\"layout\" [class.active]=\"stateActiveLayout\"></div><header-component></header-component><router-outlet></router-outlet><modal-component></modal-component><modal-help-addon-progress-component></modal-help-addon-progress-component></main>";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/main.component.pug
// module id = 1043
// module chunks = 0